import { render, staticRenderFns } from "./mzHerbal.vue?vue&type=template&id=f702d4ca&scoped=true"
import script from "./mzHerbal.vue?vue&type=script&lang=js"
export * from "./mzHerbal.vue?vue&type=script&lang=js"
import style0 from "./mzHerbal.vue?vue&type=style&index=0&id=f702d4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f702d4ca",
  null
  
)

export default component.exports